/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderConstants } from './OrderConstants';
import {
    OrderConstantsFromJSON,
    OrderConstantsFromJSONTyped,
    OrderConstantsToJSON,
} from './OrderConstants';

/**
 * 
 * @export
 * @interface SortProperty
 */
export interface SortProperty {
    /**
     * 
     * @type {string}
     * @memberof SortProperty
     */
    id: string;
    /**
     * 
     * @type {OrderConstants}
     * @memberof SortProperty
     */
    order?: OrderConstants;
}

/**
 * Check if a given object implements the SortProperty interface.
 */
export function instanceOfSortProperty(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function SortPropertyFromJSON(json: any): SortProperty {
    return SortPropertyFromJSONTyped(json, false);
}

export function SortPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': !exists(json, 'order') ? undefined : OrderConstantsFromJSON(json['order']),
    };
}

export function SortPropertyToJSON(value?: SortProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order': OrderConstantsToJSON(value.order),
    };
}

